import $ from 'jquery';
import _ from 'lodash';

export default function videosDirective(context=document.body) {
	const $context = $(context);

	$(function () {
		const videos = $('.media.-type-video');

		if (videos.length > 0) {
			videos.each(function(){
				let _this = $(this);
				let video = _this.find('video')[0];
				let button = _this.find('.video-icon');
				// video.currentTime = 1;

				video.pause();
				video.muted = false;
				video.currentTime = 0;

				button.click(_.debounce(function(){
					if (_this.hasClass('is-played')) {
						_this.removeClass('is-played');
						video.pause();
					} else {
						_this.addClass('is-played');
						video.play();
					}
				}, 100));

				$(video).click(_.debounce(function(){
					if (_this.hasClass('is-played')) {
						_this.removeClass('is-played');
						video.pause();
					} else {
						_this.addClass('is-played');
						video.play();
					}
				}, 100));

				$(video).on('ended',function(){
					_this.removeClass('is-played');
				});
			});
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/videos.js